import Routers from './router'
import repertoryStore from './store'
export default {
    install(vaue, {router, store}){
        router.addRoute(Routers)
        store.registerModule('repertoryModule', repertoryStore)
    }
}